<template>
  <AboutPage />
</template>
<script>
import AboutPage from "@/components/AboutPage.vue";
const components = {
  AboutPage,
};
export default {
  name: "about",
  components,
};
</script>
